module.exports = __webpack_public_path__ + "static/media/linkedin.0ef94be5.svg";